export type P7CheckStatus = "pass" | "flag" | "fail" | "pending";

export type P7ChecklistItem = {
    id: string;
    category: string;
    criterion: string;
    status: P7CheckStatus;
    notes: string;
    weight: number;
    owner?: string;
    deadline?: string;
};

export type P7Slide = {
    number: number;
    title: string;
    key_points: string;
    visual: string;
};

export type P7FormData = {
    gate_status: "pending" | "approved" | "changes_requested";
    checklist: P7ChecklistItem[];
    blockers: string;
    slides: P7Slide[];
    override_justification: string;
};

export function defaultP7FormData(): P7FormData {
    return {
        gate_status: "pending",
        checklist: [],
        blockers: "",
        slides: [],
        override_justification: "",
    };
}

export function computeAdherence(checklist: P7ChecklistItem[]): number {
    if (checklist.length === 0) return 0;
    const total = checklist.reduce((s, i) => s + (i.weight || 1), 0);
    const earned = checklist
        .filter((i) => i.status === "pass")
        .reduce((s, i) => s + (i.weight || 1), 0);
    return total > 0 ? Math.round((earned / total) * 1000) / 10 : 0;
}
